import {Button} from "../ui-components/Button/Button";
import React, {useContext, useEffect, useState} from "react";
import {ToastService} from "../../service/ToastService";
import {PreviewDataContext} from "../../context/PreviewContext";
import {SignatureModal} from "../SignatureModal/SignatureModal";
import {InvoiceContext} from "../../context/InvoiceContext";
import {acceptSignaturesAsync} from "../../api/SignatureApi";
import {PromptModal} from "../Modal/PromptModal";
import {PageContext} from "../../context/PageContext";
import {PreloaderContext} from "../../context/PreloaderContext";
import {AddOnItemsContext} from "../../context/AddOnItemsContext";
import {OptionContext} from "../../context/OptionContext";
import {CONSTANTS} from "../../common/constants";
import {SignerNameModal} from "../SignerNameModal/SignerNameModal";
import {isOfflineMode} from "../../utils/util-functions";


export const SignatureSignIn: React.FunctionComponent = (props) => {
    const previewContext = useContext(PreviewDataContext);
    const invoice = useContext(InvoiceContext);
    const optionContext = useContext(OptionContext);
    const [signatureModalVisible, setSignatureModalVisible] = useState<boolean>(false);
    const [signatures, setSignatures] = useState<string[]>([]);
    const [showMoreSignaturesPrompt, setShowMoreSignaturesPrompt] = useState<boolean>(false);
    const [signerNameModalVisible, setSignerNameModalVisible] = useState<boolean>();
    const pageContext = useContext(PageContext);
    const preloaderContext = useContext(PreloaderContext);
    const optionalItemContext = useContext(AddOnItemsContext);

    useEffect(() => {
        if (pageContext.isPaymentAcceptedSignaturePage()) {
            onClick();
        }
    }, [pageContext.isPaymentAcceptedSignaturePage()]);

    const onClick = () => {
        if (!optionContext.selectedOption) {
            ToastService.middleScreenWarningToast(CONSTANTS.NO_SELECTED_OPTION_TOAST_WARNING_TEXT);
            return;
        }
        setSignatureModalVisible(true);
    }

    const onCloseSignatureModal = () => {
        pageContext.setPaymentAcceptedSignatureMode(false);
        setSignatureModalVisible(false);
    }

    const onSubmitSignatureModal = (signatureContent: string) => {
        onCloseSignatureModal();
        signatures.push(signatureContent);
        setSignatures(signatures);
        setSignatureModalVisible(false);
        if (signatures.length === invoice.contract_signature_lines) {
            openSignerNameModal();
        } else {
            setShowMoreSignaturesPrompt(true);
        }
    }

    const sendSignatureRequest = async (signerName: string) => {
        preloaderContext.showMiddlePagePreloader();
        const selectedAddOnOptionIds = optionContext.selectedAddOnOptions.map((option) => option.id);
        const response = await acceptSignaturesAsync(signatures, previewContext.isPreviewMode, optionContext.selectedOption?.id as number, selectedAddOnOptionIds, previewContext.searchString, signerName as string).catch(() => {
        });
        preloaderContext.hideMiddlePagePreloader();
        if (response && !response.error) {
            notifyAboutAcceptedSignature(response.response);
            pageContext.setPageData({pdf_url: response?.response?.pdf_url});
            pageContext.setPage(response?.response?.status);
        } else if (!response || (response && response.error)) {
            if (response && response.errors && response.errors.length) {
                ToastService.middleScreenErrorToast(response.errors.join('\n'));
            } else {
                ToastService.middleScreenErrorToast('Please try again or contact FieldPulse support.');
            }
        }
    }

    const notifyAboutAcceptedSignature = (response: { pdf_url: string, pdf_id: number }) => {
        try {
            const notifyObject = {
                type: 'fp-invoice',
                action: 'signed',
                data: {signed_file: {id: response.pdf_id, url: response.pdf_url}}
            };
            if (window.parent) {
                window.parent.postMessage(notifyObject, '*');
            }

            if ((window as any).Android && (window as any).Android.postMessage) {
                (window as any).Android.postMessage(JSON.stringify(notifyObject));
            }
        } catch {

        }
    }

    const onConfirmMoreSignaturesCallback = () => {
        setShowMoreSignaturesPrompt(false);
        setSignatureModalVisible(true);
    }

    const onDeclineMoreSignaturesCallback = () => {
        setShowMoreSignaturesPrompt(false);
        openSignerNameModal();
    }

    const onCloseSignerNameModal = () => {
        setSignerNameModalVisible(false);
    }

    const openSignerNameModal = () => {
        setSignerNameModalVisible(true);
    }

    const onSubmitSignerNameModal = (signerName: string) => {
        if (isOfflineMode()) {
            sendOfflineSignatureRequest(signerName);
        } else {
            sendSignatureRequest(signerName);
        }
    }

    const sendOfflineSignatureRequest = (signerName: string) => {
        const selectedAddOnOptionIds = optionContext.selectedAddOnOptions.map((option) => option.id);
        const data = {
            signatures,
            is_preview: true,
            selected_option_id: optionContext.selectedOption?.id as number,
            selected_add_on_options_ids: selectedAddOnOptionIds,
            signature_name: signerName
        };
        window.parent.postMessage({type: 'fp-offline-invoice', action: 'accept-signature', data}, '*')
    }

    return (
        <>
            {
                signatureModalVisible
                    ? <SignatureModal onSubmitModal={onSubmitSignatureModal} onCloseModal={onCloseSignatureModal}/>
                    : null
            }


            {
                signerNameModalVisible
                    ? <SignerNameModal onSubmitModal={onSubmitSignerNameModal} onCloseModal={onCloseSignerNameModal}/>
                    : null
            }

            {showMoreSignaturesPrompt && <PromptModal onConfirmCallback={onConfirmMoreSignaturesCallback}
                                                      onDeclineCallback={onDeclineMoreSignaturesCallback}>Do you want to
                add one more signature?</PromptModal>}
            <Button onClick={onClick} className="payment-button green-button">
                <i className="fa-regular fa-signature"></i>
                Sign and Accept
            </Button>
        </>
    );
}
